var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import XCloseSvg from './x-close.icon.svg';
export const XCloseIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: XCloseSvg }));
_react_refresh_temp_1 = XCloseIcon;
$RefreshReg$(_react_refresh_temp_1, "XCloseIcon");
